module.exports = __webpack_public_path__ + "static/media/img_5.f3ac3df2.png";